import { render, staticRenderFns } from "./workOrderList.vue?vue&type=template&id=5a2f27b4&scoped=true&"
import script from "./workOrderList.vue?vue&type=script&lang=ts&"
export * from "./workOrderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f27b4",
  null
  
)

export default component.exports